import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { IAppState } from "../../Common";
import { load } from "..";
import { useLoggedInUser } from "../../Auth";
/** Loads project currentProjectId into redux state from server */
const useTags = () => {
  const dispatch = useDispatch();
  const currentTags = useSelector((state: IAppState) => state.tags);
  const user = useLoggedInUser();
  useEffect(() => {
    if (
      !!user &&
      !currentTags.loadingState.isLoaded &&
      !currentTags.loadingState.isLoading &&
      !currentTags.loadingState.errored
    )
      dispatch(load());
  }, [currentTags]);

  return currentTags;
};

export default useTags;
